import { useMemo } from 'react';
import { useCurrentUser } from '@centecomm/portal-service-react';
import useLaunchDarkly from 'utils/Hooks/LaunchDarkly/useLaunchDarkly';
import useCheckIfCurrentCompanyIsPECO from 'utils/Hooks/CompanySpecific/PECO/useCheckIfCurrentCompanyIsPECO';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

/**
 * This hook is used to determine if the Peco Qualtrics snippet should be loaded.
 * It checks the following conditions:
 * 1. The Peco Qualtrics flag is enabled in LaunchDarkly
 * 2. The current company is PECO
 * 3. The user is a tenant (very important)
 */
function usePecoQualtrics(): boolean {
    const { isCurrentCompanyDetermined, idMatch: isPECOCurrentCompany } = useCheckIfCurrentCompanyIsPECO();
    const { isTenant } = useCurrentUser();
    const pecoQualtricsFlag = useLaunchDarkly(LaunchDarklyFlags.PecoQualtrics);

    return useMemo(
        () => pecoQualtricsFlag && isCurrentCompanyDetermined && isPECOCurrentCompany && isTenant,
        [pecoQualtricsFlag, isCurrentCompanyDetermined, isPECOCurrentCompany, isTenant],
    );
}

export default usePecoQualtrics;
